export class Purpose {
  id: number;
  description: string;
  name: string;

}
